<template>
  <div class="page">
    <main-menu-bar/>
    <div class="page-inner">
      <header class="p-d-flex p-ai-center">
        <label class="p-mr-3">Width</label>
        <slider v-model="containerWidth" :min="10" :max="100"/>
        <label class="p-ml-3 p-mr-3">Font size</label>
        <slider v-model="fontSize" :min="10" :max="72"/>
      </header>
      <div v-if="motion">
        <div class="speakers-list-container" :style="{width: `${containerWidth}%`, 'font-size': `${fontSize}px`}">
          <speakers-list :motion="motion"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpeakersList from '../speakers/SpeakersList.vue'
import MainMenuBar from '../nav/MainMenuBar.vue'
import Slider from 'primevue/slider'

export default {
  name: 'CurrentMotionSpeakers',
  components: {
    SpeakersList,
    MainMenuBar,
    Slider
  },
  async created () {
    await this.$store.dispatch('motions/loadCurrent')
  },
  computed: {
    motion () {
      return this.$store.getters['motions/current']
    }
  },
  data: function () {
    return {
      fontSize: 16,
      containerWidth: 50
    }
  }
}
</script>

<style scoped>
.p-slider {
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/SpeakersListPage.vue